import fvIconSmall from 'assets/icons/iconFvSmall.svg'
import Button from 'components/common/Button'
import * as Common from 'components/common/Common'
import * as Typography from 'components/common/Typography'
import InputIncrementer from 'components/inputs/InputIncrementer'
import ModalCardsPrinting from 'components/modals/ModalCardsPrinting'
import ModalInvoicePrinting from 'components/modals/ModalInvoicePrinting'
import ReservationSteps from 'components/views/ReservationDetailsSteps/ReservationSteps'
import { RESERVATION_STEP_PRINT_CARDS } from 'constants/app'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectIsKiosk } from 'redux/slices/app'
import { checkIn } from 'redux/slices/booking/bookingSlice'
import {
  selectReservationError,
  selectReservationStatus,
} from 'redux/slices/reservation/reservationSelectors'
import { moveToGate } from 'redux/slices/reservation/reservationSlice'
import { dispatch, RootState } from 'redux/store'
import { notify, ToastTypes } from 'shared-ui'
import {
  BackCard,
  RoomCard,
} from 'views/kiosk/makeReservation/ViewMakeReservationPrintCardKiosk.styled'

const ViewMakeReservationPrintCardKiosk = () => {
  const { t } = useTranslation()
  const bookingDetails = useSelector(
    (state: RootState) => state.booking.bookingDetails?.data ?? null
  )
  const cardsForm = useForm({
    defaultValues: {
      cardsAmount: 1,
    },
  })
  const [isCardPrintingModalOpen, setIsCardPrintingModalOpen] = useState(false)
  const [isInvoicePrintingModalOpen, setIsInvoicePrintingModalOpen] =
    useState(false)
  const reservationStatus = useSelector(selectReservationStatus)
  const reservationError = useSelector(selectReservationError)
  const isKiosk = useSelector(selectIsKiosk)

  const handlePrintCard = async () => {
    const cardsAmount = cardsForm.getValues('cardsAmount')
    const bookingUuid = bookingDetails?.uuid

    if (!bookingUuid) {
      notify('Brak UUID rezerwacji')[ToastTypes.ERROR]()
      return
    }

    setIsCardPrintingModalOpen(true)

    await dispatch(moveToGate({ bookingUuid, numberOfCards: cardsAmount }))

    if (isKiosk) {
      await dispatch(checkIn(bookingUuid))
    }

    if (reservationStatus === 'succeeded') {
      // notify(verifyMessage)[ToastTypes.SUCCESS]()
    } else if (reservationStatus === 'failed') {
      notify(reservationError)[ToastTypes.ERROR]()
    }
  }

  return (
    <Common.Div pt={3}>
      <Common.Div
        alignItems="center"
        flex="column"
      >
        <ReservationSteps
          step={RESERVATION_STEP_PRINT_CARDS}
          withStepBars={false}
        />
      </Common.Div>
      <Common.Div
        flex="column"
        alignItems="center"
      >
        <Typography.H4
          mb={2}
          secondary
        >
          {t('cardPrinting.readyForPrinting')}
        </Typography.H4>
        <Typography.Body1
          secondary
          mb={2}
        >
          {t('cardPrinting.howMany')}
        </Typography.Body1>
        <InputIncrementer
          name="cardsAmount"
          form={cardsForm}
        />
        <Common.Div
          flex="row"
          mb={2}
          mt={2}
        >
          <RoomCard />
          <BackCard />
        </Common.Div>
        <Common.Div fullyCentered>
          <Button
            type="button"
            onClick={handlePrintCard}
          >
            <Common.SvgIcon
              src={fvIconSmall}
              mr={2}
            />
            {t('cardPrinting.modal.printButton')}
          </Button>
        </Common.Div>
      </Common.Div>
      <ModalCardsPrinting
        bookingDetails={bookingDetails}
        isOpen={isCardPrintingModalOpen}
        setInvoicePrintingModalIsOpen={setIsInvoicePrintingModalOpen}
        setIsOpen={setIsCardPrintingModalOpen}
      />
      <ModalInvoicePrinting
        isOpen={isInvoicePrintingModalOpen}
        setIsOpen={setIsInvoicePrintingModalOpen}
      />
    </Common.Div>
  )
}

export default ViewMakeReservationPrintCardKiosk
